import { render, staticRenderFns } from "./tableMain.vue?vue&type=template&id=37e8a323&scoped=true"
import script from "./tableMain.vue?vue&type=script&lang=js"
export * from "./tableMain.vue?vue&type=script&lang=js"
import style0 from "./tableMain.vue?vue&type=style&index=0&id=37e8a323&prod&lang=scss&scoped=true"
import style1 from "./tableMain.vue?vue&type=style&index=1&id=37e8a323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8a323",
  null
  
)

export default component.exports